import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ceb0082"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "booking-nav"
}
const _hoisted_2 = { class: "booking-nav__left-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.displayNav)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.isFirstStep)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  onClick: _withModifiers(_ctx.prevStep, ["stop"]),
                  class: "button--white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.goBack")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.displayCancelBtn)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 1,
                  onClick: _withModifiers(_ctx.cancel, ["stop"]),
                  loading: _ctx.loading,
                  disabled: _ctx.loading,
                  class: "button--transparent"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isLastStep && _ctx.displayContinueBtn)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 0,
                onClick: _withModifiers(_ctx.forward, ["stop"]),
                loading: _ctx.loadingNextStep,
                disabled: _ctx.loadingStep
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("nav.continue")), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading", "disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}